import React from 'react';
import PropTypes from 'prop-types';

import CustomTypes from '../../types';

import { CardStyled, CardLinkStyled } from './Card.styled';

const Card = ({ children, to, ...props }) => (
  to ? (
    <CardLinkStyled to={to} {...props}>
      {children}
    </CardLinkStyled>
  ) : (
    <CardStyled {...props}>
      {children}
    </CardStyled>
  )
);

export default Card;

Card.propTypes = {
  as: PropTypes.string,
  modifiers: CustomTypes.oneOrMore(['', 'wBorder', 'wShadow', 'active']),
  children: PropTypes.node,
};

Card.defaultProps = {
  as: '',
  modifiers: '',
  children: '',
};
